import { IDemo, E3DDemoNameVals, DemoIds } from 'types'
import { getSharedAsset } from '../../helpers/utils'

const video = getSharedAsset('speed-of-thought.mp4', 'demos', 'videos')
const poster = getSharedAsset('speed-of-thought.png', 'demos', 'posters')
const monolith = getSharedAsset('speed-of-thought.png', 'demos', 'monoliths')
const nextDemoThumbnail = getSharedAsset('5g-mec-and-smart-venues.png', 'demos', 'thumbnails')

export const speedOfThought: IDemo = {
  id: DemoIds.speedOfThought,
  type: 'sot',
  video,
  monolith,
  poster,
  end: {
    header: 'Speed of Thought',
    body:
      'From robotic devices that could allow doctors to perform surgeries thousands of miles away to a smart city that aims to eliminate pedestrian deaths, innovators are using 5G to change the world as we know it. Visit <a target="_blank" href="https://speedofthoughtfilm.com">speedofthoughtfilm.com</a> and learn where you can watch the film.',
    nextDemoText: '5G MEC and smart venues.',
    nextDemoId: DemoIds.mecAndSmartVenues,
    nextDemo: E3DDemoNameVals.mecAndSmartVenues,
    nextDemoThumbnail,
    previousDemoId: DemoIds.transformationOfHealthcare
  }
}
